import * as fromViewer from '../actions/viewer.action';

import { MappingOptions, Part, Result } from '@usimweb/core/models';

export interface ViewerState {
  info: any;
  mappingOptions: MappingOptions;
  parts: Part[];
  results: Result[];
}

export const initialState: ViewerState = {
  info: {} as any,
  mappingOptions: {} as MappingOptions,
  parts: [],
  results: [],
};

export function reducer(state = initialState, action: fromViewer.ViewerActions): ViewerState {
  // console.log('called viewer reducer');
  // console.log(action.type);

  switch (action.type) {
    case fromViewer.ADD_INFO: {
      const info = action.payload;

      return {
        ...state,
        info,
      };
    }

    case fromViewer.ADD_MAPPING_OPS: {
      const mappingOptions = action.payload;
      //const mappingOptions = { ...state.mappingOptions, ...newState };
      return {
        ...state,
        mappingOptions,
      };
    }

    case fromViewer.ADD_PART: {
      const parts = action.payload;

      return {
        ...state,
        parts,
      };
    }

    case fromViewer.DELETE_PART: {
      const index = action.payload;

      const parts = state.parts.filter((x, i) => i === index);

      return {
        ...state,
        parts,
      };
    }

    case fromViewer.ADD_RESULT: {
      const results = action.payload;

      return {
        ...state,
        results,
      };
    }

    case fromViewer.CLEAR_VIEWER: {
      return {
        ...state,
        info: {},
        mappingOptions: {} as MappingOptions,
        parts: [],
        results: [],
      };
    }
  }

  return state;
}

export const getState = (state: ViewerState) => state;
// export const getMappingLoading = (state: MappingState) => state.loading;
// export const getMappingLoaded = (state: MappingState) => state.loaded;
